import { SB } from '@play-co/replicant';

export const native = SB.object({
  // native app last launched timestamp
  // If this is 0, player has never been on iOS
  appleLastLaunched: SB.int().min(0),
  googleLastLaunched: SB.int().min(0),

  // Last time user launched any native app.
  lastNativeEntry: SB.int().min(0).optional(),

  // We should give reward for success installation
  // idle - Reward was never given to user and user didn't saw promo popup
  // saw_promo - User saw promo and next state will be `received` reward
  // received - Waiting for claim UI on login
  // claimed - Player already claimed reward
  // rejected - Player installed app without promo so player never get reward for it
  appInstallRewardStatus: SB.tuple([
    'idle', //       idle => 'saw_promo' or 'rejected'
    'saw_promo', //  saw_promo => 'received'
    'received', //   received => 'claimed'
    'claimed', //    claimed => END
    'rejected', //   rejected => END
  ]).default('idle'),

  // Incentivised app update reward status
  // idle - Never saw incentivised update popup
  // saw_promo - User saw incentivised update popup
  // received - User updated app and is ready to claim reward
  // claimed - Player already claimed the update reward
  appUpdateRewardStatus: SB.tuple([
    'idle', //       idle => 'saw_promo'
    'saw_promo', //  saw_promo => 'received' (when app version updated)
    'received', //   received => 'claimed'
    'claimed', //    claimed => END
  ]).default('idle'),

  // Store payload for session resume.
  payload: SB.string().optional(),

  /**
   * If set to true we're tracking user native app re-installs.
   * Only on native app, before we set this flag to true we also set local storage flag.
   * If user re-install app it will clear local storage, and we can detect possible re-install by checking this flag and local storage flag.
   *
   * @see User property `lastEntryIsFirstOfNativeInstall`
   */
  isFirstOfNativeInstallTracked: SB.boolean().default(false),

  /**
   * When we last time updated device push notification token
   */
  pushNotificationTokenUpdatedAt: SB.int().min(0).default(0),
});
